import * as React from 'react';
import { SiteRoute } from '@journeyapps/package-types';
import { BLOG_POSTS } from '../../pages/blog/shared/blog';
import { BlogCardWidget } from '../../pages/blog/shared/BlogCardWidget';
import { CardGridWidget } from '../CardGridWidget';
import { HomeSectionHeader } from './HomeSectionHeader';
import { HomeActionCards } from './HomeActionCards';

export const HomeNewsSection: React.FC = () => (
  <section aria-labelledby="home-news">
    <HomeSectionHeader id="home-news" title="Keep exploring." to={SiteRoute.BLOG} linkLabel="All news" />
    <CardGridWidget columns={3}>
      {BLOG_POSTS.slice(0, 2).map((post) => (
        <BlogCardWidget key={post.frontmatter.permalink} post={post} />
      ))}
      <HomeActionCards />
    </CardGridWidget>
  </section>
);
